import React, { memo } from 'react';
import {
  getSmoothStepPath,
  getEdgeCenter,
  getMarkerEnd,
  useReactFlow
} from "react-flow-renderer";

import "./css/buttonedge.css";
import { DeleteOutlined as Delete } from '@mui/icons-material';



const onEdgeClick = (evt, id, setEdges) => {
  evt.stopPropagation();
  setEdges((edges) => edges.filter((e) => e.id !== id));
};

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  arrowHeadType,
  markerEndId,
  selected
}) => {
  const { setEdges } = useReactFlow();

  const edgePath = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 20
  });

  const markerEnd = markerEndId ? `url(#${markerEndId})` : null;

  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY
  });

  const foreignObjectSize = 40;

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      {selected && (
        <foreignObject
          width={foreignObjectSize}
          height={foreignObjectSize}
          x={edgeCenterX - foreignObjectSize / 2}
          y={edgeCenterY - foreignObjectSize / 2}
          className="edgebutton-foreignobject"
          requiredExtensions="http://www.w3.org/1999/xhtml"
        >
          <div style={{ background: "transparent", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <button
              className="edgebutton"
              onClick={(event) => onEdgeClick(event, id, setEdges)}
            >
              <Delete sx={{ width: "16px", height: "16px", color: "#F44336" }} />
            </button>
          </div>
        </foreignObject>
      )}
    </>
  );
};

export default memo(CustomEdge);
